import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {MessageAdmin,MessageAdminType} from "@domain/admin/bibliotheque/notification/message-admin";
import {TranslateService} from "@ngx-translate/core";
import {NotificationService} from "@services/admin/bibliotheque/notification.service";
import {ToastrService} from "ngx-toastr";
import {handleResult} from "@share/utils/handle-result";
import {ConfirmService} from "@share/component/confirmation/confirm.service";
import {filter} from "rxjs/operators";

/**
 * Composant d'affichage des items de la liste des message pour l'accueil
 *
 * @author Lionel Gimenez
 * @date 24/03/2026
 */
@Component({
    host: {'data-test-id': 'accueil-item'},
    selector: 'accueil-item',
    templateUrl: './accueil-item.component.html'
})
export class AccueilItemComponent extends ListViewItem<MessageAdmin> {
    /** Déclaration pour le template */
    MessageAdminType = MessageAdminType;

    /**
     * Constructeur
     *
     * @param translateService Service de traduction
     * @param notificationService Service de notification
     * @param toastrService Service de notification
     * @param confirmService Service de confirmation
     */
    constructor(
        public translateService: TranslateService,
        public notificationService: NotificationService,
        public toastrService: ToastrService,
        private confirmService: ConfirmService
    ) {
        super();
    }

    /**
     * Vérifie si le message est actuellement affiché
     *
     * @returns true si le message est actif et dans la plage de dates
     */
    get isAffiche(): boolean {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return this.data.actif
            && (!this.data.dateDebut || new Date(this.data.dateDebut) <= today)
            && (!this.data.dateFin || new Date(this.data.dateFin) >= today);
    }

    /**
     * Handler du delete
     */
    onDelete(): void {
        //Affichage de la confirmation de suppression
        this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation'))
            .pipe(filter(isConfirmed => isConfirmed))
            .subscribe({
                next: () => {
                    //Suppression du message
                    this.notificationService.deleteMessage(this.data.idMessage)
                        .pipe(handleResult(this.translateService,this.toastrService,'global.success.suppression','global.errors.suppression'))
                        .subscribe(() => this.liste.refresh());
                }
            });
    }
}
